import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage, project } from "../../config/constants";
//Components
import { FooterContainer, AddPatientContainer } from "./styles";
import ButtonWithIcon from "../buttonWithIcon";
// Assets
import AddPatient from "../../assets/icons/ico_add_patient.svg";

const Footer = () => {
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const [t] = useTranslation("global");

  const renderNewPatientButton = () => {
    const showNewPatientButton = () => {
      return (project === "global" && clinicianData.CLINICIAN_USER !== "Artem") || (project === "strack" && clinicianData.ROLE === "ADMIN");
    };

    if (showNewPatientButton()) {
      return (
        <AddPatientContainer>
          <ButtonWithIcon icon={AddPatient} name={t("home_newPatientButton")} path={`${pathHomePage}/add-patient/${clinicianData.token}`} />
        </AddPatientContainer>
      );
    }
  };

  return <FooterContainer>{renderNewPatientButton()}</FooterContainer>;
};

export default Footer;
